
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { RatingModule } from 'ngx-bootstrap/rating';

import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';

import { VbRatingComponent } from './VbRating.Component';


@NgModule({
	declarations: [
		VbRatingComponent
	],
	exports: [
		VbRatingComponent
	],
	imports: [
		CommonModule,
		CssRulesAngularModule,
		FormsModule,
		RatingModule
	]
})

export class VbRatingModule { }
